// extracted by mini-css-extract-plugin
export default {"PopoverInstance":"📚19-10-2_G_vp"};